module.exports = __webpack_public_path__ + "img/4.44185675.jpg";